import {createStore} from 'redux';
import configureMockStore from 'redux-mock-store';
import {persistStore, persistReducer} from 'redux-persist';
import localForage from 'localforage';
import {generateAppliedMiddleware, createReduxHistory} from './middlewares';
import generateReducers from './reducers';

const persistConfig = {
  'key': 'primary',
  'storage': localForage,
};

let reduxStore, history;

const generateStore = (customMiddlewares, customReducers) => {
  const appliedMiddleware = generateAppliedMiddleware(customMiddlewares);
  const rootReducer = generateReducers(customReducers);
  const persistedReducers = persistReducer(persistConfig, rootReducer);
  // create the store
  const store = createStore(persistedReducers, {}, appliedMiddleware);
  reduxStore = persistStore(store, {}, () => store.getState());
  history = createReduxHistory(store);
  return store;
};

const mockMiddlewares = [];
const mockStore = configureMockStore(mockMiddlewares);

export {generateStore, mockStore, reduxStore, history};
